module.exports = __webpack_public_path__ + "img/placenta.02d8cf90.png";